export const createAddRecorderAudioWorkletModule = (blobConstructor, urlConstructor, worklet) => {
    return async (addAudioWorkletModule) => {
        const blob = new blobConstructor([worklet], { type: 'application/javascript; charset=utf-8' });
        const url = urlConstructor.createObjectURL(blob);
        try {
            await addAudioWorkletModule(url);
        }
        finally {
            urlConstructor.revokeObjectURL(url);
        }
    };
};
//# sourceMappingURL=add-recorder-audio-worklet-module.js.map